import { AlphaMCircleOutlineIcon } from './AlphaMCircleOutlineIcon';

/**
 * author: Contributors
 * id F85ABB66-FEE7-46ED-9DE3-AB3B24597863
 * name alpha-m-circle-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-m-circle-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterMCircleOutlineIcon = AlphaMCircleOutlineIcon;
export default LetterMCircleOutlineIcon